import { Box } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  tabId?: string;
  panelId?: string;
}

export default function TabPanel(props: Readonly<TabPanelProps>) {
  const { children, value, index, tabId, panelId, ...other } = props;

  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      id={panelId ?? `tabpanel-${index}`}
      aria-labelledby={tabId ?? `tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}
